var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.667 5.99984H23.3337V16.6665C23.3337 17.3998 22.7337 17.9998 22.0003 17.9998H6.00033V19.3332C6.00033 20.7998 7.20033 21.9998 8.66699 21.9998H22.0003L27.3337 27.3332V8.6665C27.3337 7.19984 26.1337 5.99984 24.667 5.99984ZM20.667 12.6665V3.33317C20.667 1.8665 19.467 0.666504 18.0003 0.666504H3.33366C1.86699 0.666504 0.666992 1.8665 0.666992 3.33317V20.6665L6.00033 15.3332H18.0003C19.467 15.3332 20.667 14.1332 20.667 12.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWhite);
export default __webpack_public_path__ + "static/media/chatWhite.158124337a3320bbd2bae579c8993f07.svg";
export { ForwardRef as ReactComponent };